import React from 'react';
import axios from '../axios';
import ModalAlert from '../redux/components/modal/modal_alert';
import ModalLoader from '../modal/modal_loader';

const UserfeedCreate = (props) => {
  const [userfeedId, setUserfeedId] = React.useState(null);
  const [tag, setTag] = React.useState('');
  const [image, setImage] = React.useState(null);
  const [body, setBody] = React.useState("");
  const modalLoaderRef = React.useRef(null);
  const modalAlertSuccessRef = React.useRef(null);
  const modalAlertErrorRef = React.useRef(null);

  const submit = React.useCallback(() => {
    if (!body) return;

    modalLoaderRef.current.openModal();

    const data = new FormData();
    tag === '' ? data.append('tag', null) : data.append('tag', tag);
    tag === '' ? data.append('body', body) : data.append('body', body + '\n' + '#' + tag);
    if (image) {
      data.append('image', image);
    }
    if (props.company_id) {
      data.append('company_id', props.company_id);
    }
    if (props.circle_id) {
      data.append('circle_id', props.circle_id);
    }

    axios
      .post(`/api/userfeeds`, data, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      })
      .then((res) => {
        setUserfeedId(res.data.userfeed_id);

        modalLoaderRef.current.closeModal();
        modalAlertSuccessRef.current.openModal();
      })
      .catch(() => {
        modalLoaderRef.current.closeModal();
        modalAlertErrorRef.current.openModal();
      });
  }, [tag, body, image]);

  const toUserfeedPage = React.useCallback(() => {
    modalAlertSuccessRef.current.closeModal();
    modalAlertErrorRef.current.closeModal();
    window.location.href = '/community/' + props.company_id + '/userfeeds/' + userfeedId;
  }, [userfeedId]);

  return (
    <div>
      <main className="h-100 min-vh-100">
        <section id="content">
          <div className="container col-md-10 col-lg-8">
            <h1 className="font-weight-bold text-black-333 mb-2_5 mt-4 text-fz-20px">
              みんなとやってみたいことを書こう！
            </h1>
          </div>
          <div className="shadow-sm mb-3 bg-white">
            <div className="container col-md-10 col-lg-8 px-3 py-3">
              <p className="text-fz-14px text-fw-bold text-black-50 mb-2 d-inline-block">
                タグ
              </p>
              <select
                id="tag-select"
                onChange={(e) => {
                  setTag(e.target.value === '' ? null : e.target.value);
                }}
                value={tag}
                className="form-select form-control w-100 p-1"
              >
                <option value={''}>なし</option>
                <option value={'やってみたいこと'}>#やってみたいこと</option>
                <option value={'食べたいもの'}>#食べたいもの</option>
                <option value={'行きたい場所'}>#行きたい場所</option>
                <option value={'今ハマっていること'}>#今ハマっていること</option>
              </select>
            </div>
            <div className="container col-md-10 col-lg-8 px-3 py-3">
              <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-1 d-inline-block">
                {tag}
              </p>
              <textarea
                id="body-textarea"
                className={`p-1 w-100 form-control`}
                placeholder={
                  '東京タワーに階段で登ってみたいです。上に登ると絶景で感動するらしいので、興味のある方いませんか？'
                }
                value={body}
                onChange={(e) => {
                  setBody(e.target.value);
                }}
                rows={'12'}
              />
            </div>
            <div className="container col-md-10 col-lg-8 px-3 pt-3">
              <p className="text-fz-14px text-fw-bold text-black-50 mb-2 d-inline-block">
                画像
              </p>
              <p className="text-fz-small text-black-50">
                ※ 画像をタップして登録できます。
              </p>
            </div>
            <div className="container col-md-10 col-lg-8 px-3 pb-3">
              <label htmlFor="image_data">
                <a
                  className="card border-0 d-flex justify-content-center align-items-center hov--default p-3_5 d-block cursor-pointer"
                >
                  <img
                    src={image ? URL.createObjectURL(image) : "/assets2019/img/icon_camera.svg"}
                    alt="preview"
                    className="card-img-top card-img-top--list_eventreport mb-0 w-100 cursor-pointer"
                  />
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(e) => {
                      setImage(e.target.files[0]);
                    }}
                    id="image_data"
                    style={{ display: "none" }}
                  />
                </a>
              </label>
            </div>

            <div className="container col-md-10 col-lg-8 px-3 py-3">
            <button
              className="a-button a-button__top a-button--orange mt-5 mb-5 w-100"
              onClick={() => submit()}
            >
                送信する
              </button>
            </div>
          </div>
        </section>
      </main>
      <ModalAlert
        ref={modalAlertSuccessRef}
        id="modalAlertDraftSuccess"
        title="送信完了"
        content="投稿完了しました。"
        approveFunc={() => toUserfeedPage()}
      />
      <ModalAlert
        ref={modalAlertErrorRef}
        id="modalAlertError"
        title="送信失敗"
        content='投稿に失敗しました。時間をおいてもう一度お試しください。'
      />
      <ModalLoader ref={modalLoaderRef} />
    </div>
  );
};

export default UserfeedCreate;
